import _asyncToGenerator from "/root/steemboylikegirlClub/gitproject/steemboylikegirlclub/steemboylikegirlclub/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.array.sort.js";
import "core-js/modules/es.function.name.js";
import { getImgFromStr, getDateTimeStamp, getDateDiff } from "../unit/public";
import { extractLoginData, getAccount } from "../unit/UserUtil";
import dsteem from "../unit/DsteemUtil";
import PostCard from "../components/PostComponents/PostCard.vue";
import CommunityEdit from "../components/CommunityComponents/CommunityEdit.vue";
export default {
  components: {
    PostCard: PostCard,
    CommunityEdit: CommunityEdit
  },
  data: function data() {
    return {
      blogs: null,
      loginData: null,
      showLeave: false,
      isJoined: true,
      communities: null,
      community: "",
      showModel: false,
      subscribeLoad: false,
      sort: "created",
      selectPostOption: [{
        key: "New",
        value: "created"
      }, {
        key: "Trending",
        value: "trending"
      }, {
        key: "Payouts",
        value: "payout"
      }, {
        key: "Muted",
        value: "promoted"
      }]
    };
  },

  /*  watch: {
    async sort(newValue) {
      this.$router.push({
        path: "/" + this.sort + "/" + this.$route.params.community,
      });
    },
  }, */
  methods: {
    changeOrder: function changeOrder() {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.$router.push({
                  path: "/" + _this.sort + "/" + _this.$route.params.community
                });

                _context.next = 3;
                return dsteem.getBlogsByBridge(_this.loginData ? _this.loginData[0] : null, _this.sort, _this.community, 20);

              case 3:
                _this.blogs = _context.sent;

                _this.$refs.loadmoreRef.checkSroll();

              case 5:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    onRefresh: function onRefresh(done) {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return dsteem.getBlogsByBridge(_this2.loginData ? _this2.loginData[0] : null, _this2.sort, _this2.community, 20);

              case 2:
                _this2.blogs = _context2.sent;
                done();

              case 4:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }))();
    },
    onLoad: function onLoad(done) {
      var _this3 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var permlink, author, nextblogs;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                if (_this3.blogs[_this3.blogs.length - 1]) {
                  _context3.next = 2;
                  break;
                }

                return _context3.abrupt("return");

              case 2:
                permlink = _this3.blogs[_this3.blogs.length - 1].permlink;
                author = _this3.blogs[_this3.blogs.length - 1].author;
                _context3.next = 6;
                return dsteem.getBlogsByBridge(_this3.loginData ? _this3.loginData[0] : null, _this3.sort, _this3.community, 20, permlink, author);

              case 6:
                nextblogs = _context3.sent;
                nextblogs.shift();

                _this3.blogs.push.apply(_this3.blogs, nextblogs);

                done();

              case 10:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }))();
    },
    loadAccount: function loadAccount() {
      var _this4 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _this4.loginData = extractLoginData();

              case 1:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }))();
    },
    imgFromStr: function imgFromStr(json_metadata, body) {
      return getImgFromStr(json_metadata, body);
    },
    dateDiff: function dateDiff(dateTime) {
      return getDateDiff(getDateTimeStamp(dateTime));
    },
    subscribe: function subscribe() {
      var _this5 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
        var result;
        return regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _this5.subscribeLoad = true;
                _this5.loginData = extractLoginData();

                if (_this5.loginData) {
                  _context5.next = 7;
                  break;
                }

                _this5.$bus.emit("openLogin");

                return _context5.abrupt("return");

              case 7:
                _context5.next = 9;
                return dsteem.subscribeCommunity(_this5.communities.name, true);

              case 9:
                result = _context5.sent;
                _this5.isJoined = true;
                _this5.subscribeLoad = false;

              case 12:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5);
      }))();
    },
    unSubscribe: function unSubscribe() {
      var _this6 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6() {
        var result;
        return regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _this6.subscribeLoad = true;
                _this6.loginData = extractLoginData();

                if (_this6.loginData) {
                  _context6.next = 7;
                  break;
                }

                _this6.$bus.emit("openLogin");

                return _context6.abrupt("return");

              case 7:
                _context6.next = 9;
                return dsteem.subscribeCommunity(_this6.communities.name, false);

              case 9:
                result = _context6.sent;
                _this6.isJoined = false;
                _this6.subscribeLoad = false;

              case 12:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6);
      }))();
    },
    closeModel: function closeModel() {
      this.showModel = false;
    },
    gotoPost: function gotoPost() {
      this.loginData = extractLoginData();

      if (!this.loginData) {
        this.$bus.emit("openLogin");
        return;
      } else {
        this.$router.push({
          path: "/post/" + this.community
        });
      }
    }
  },
  mounted: function mounted() {
    var _this7 = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee7() {
      return regeneratorRuntime.wrap(function _callee7$(_context7) {
        while (1) {
          switch (_context7.prev = _context7.next) {
            case 0:
              _this7.loadAccount();

              _this7.sort = _this7.$route.params.sort;
              _this7.community = _this7.$route.params.community;
              _context7.next = 5;
              return dsteem.getBlogsByBridge(_this7.loginData ? _this7.loginData[0] : null, _this7.sort, _this7.community, 20);

            case 5:
              _this7.blogs = _context7.sent;

              if (!(_this7.blogs[0].community && _this7.blogs[0].community == _this7.community)) {
                _context7.next = 10;
                break;
              }

              _context7.next = 9;
              return dsteem.getCommunity(_this7.loginData ? _this7.loginData[0] : "", _this7.community);

            case 9:
              _this7.communities = _context7.sent;

            case 10:
            case "end":
              return _context7.stop();
          }
        }
      }, _callee7);
    }))();
  }
};